import { Form, FormGroup, Label, Input } from 'reactstrap';
import { Button } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { StartSurveyData } from '../types';
import { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

type Props = {
  teachers: StartSurveyData['teachers'];
};

export function SelectTeacherForm({ teachers }: Props) {
  const [hasAccepted, setHasAccepted] = useState(false);
  const [selectedTeacher, setSelectedTeacher] = useState<string>(
    teachers[0].id.toString(),
  );
  const { sectionId } = useParams<{
    sectionId: string;
  }>();
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <Form>
      <FormGroup>
        <Label for="teacherSelect" style={{ fontSize: 16 }} className="mb-3">
          {t(`myCourses.surveys.startSurvey.selectTeacherHeader`)}
        </Label>
        <Input
          id="teacherSelect"
          style={{ fontSize: 16, color: '#1E1E1E' }}
          name="select"
          type="select"
          onChange={(event) => setSelectedTeacher(event.target.value)}
        >
          {teachers.map((teacher) => (
            <option
              onSelect={() => console.log('first', teacher.id)}
              key={teacher.id}
              value={teacher.id}
              label={`${teacher.account.name} ${teacher.account.lastNames}`}
            />
          ))}
        </Input>
      </FormGroup>
      <FormGroup check className="mb-3">
        <Input
          id="confirmCheck"
          name="check"
          type="checkbox"
          checked={hasAccepted}
          onChange={(event) => setHasAccepted(event.target.checked)}
          style={{
            accentColor: 'var(--primary)',
            width: '20px',
            marginRight: '10px',
          }}
        />
        <Label
          check
          for="confirmCheck"
          style={{ color: '#5A5A5A' }}
          className="mb-3 ml-2"
        >
          {t(`myCourses.surveys.startSurvey.checkboxtext`)}
        </Label>
      </FormGroup>
      <Button
        onClick={() =>
          history.push(
            `/student-management/courses/${sectionId}/survey/teacher/${selectedTeacher}`,
          )
        }
        disabled={!hasAccepted}
        fullwidth
        text={t(`myCourses.surveys.startSurvey.startSurveyButton`)}
      />
    </Form>
  );
}
